// src/components/LanguageRedirect.jsx
import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const SUPPORTED_LANGUAGES = ['de', 'en', 'es', 'fr', 'th', 'ko', 'ja', 'zh-cn', 'zh-tw'];

export default function LanguageRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    const pathSegments = pathname.split('/').filter(Boolean);
    
    // 이미 언어 코드가 포함된 경우 아무것도 하지 않음
    if (pathSegments.length > 0 && SUPPORTED_LANGUAGES.includes(pathSegments[0])) {
      return;
    }

    // 언어 코드가 없는 경우 기본값(영어) 추가
    const newPath = `/en${pathname === '/' ? '' : pathname}`;
    navigate(newPath, { replace: true });
  }, [location.pathname, navigate]);

  return null;
}

